import { ExclamationMarkInOctagon } from '@/components/Icons/ExclamationMarkInOctagon';
import { Banner, type BannerRef } from '@/components/ui/banner';
import { Button } from '@music-vine/cadence/ui';
import { useRef } from 'react';
import { UpdatePaymentButton } from '@/components/UpdatePaymentButton';
export const OverduePaymentBanner = ({
  overduePaymentId,
  currentPath,
  visible
}: {
  overduePaymentId?: string;
  currentPath: string;
  visible: boolean;
}) => {
  const bannerRef = useRef<BannerRef | null>(null);
  if (!(overduePaymentId && visible)) {
    return null;
  }
  return <Banner className="h-10 bg-red-100 dark:bg-red-950" currentPath={currentPath} id="overdue-payment-banner" ref={bannerRef} showCloseButton={false} type="default" variant="top-sticky" data-sentry-element="Banner" data-sentry-component="OverduePaymentBanner" data-sentry-source-file="overdue-payment.tsx">
      <div className="flex w-full grow items-center justify-center gap-2 pl-6 sm:pl-0">
        <ExclamationMarkInOctagon className="h-4.5 w-4.5 shrink-0" data-sentry-element="ExclamationMarkInOctagon" data-sentry-source-file="overdue-payment.tsx" />
        <div className="whitespace-nowrap font-heading text-base">
          <div className="block sm:hidden">
            Your latest subscription payment failed.
          </div>
          <div className="hidden sm:block">
            Heads up! Your latest subscription payment failed.
          </div>
        </div>
        <Button asChild className="bg-red [&:is(a[href])]:hover:bg-red-950 dark:[&:is(a[href])]:hover:bg-red-950" size="sm" variant="brand" data-sentry-element="Button" data-sentry-source-file="overdue-payment.tsx">
          <UpdatePaymentButton data-sentry-element="UpdatePaymentButton" data-sentry-source-file="overdue-payment.tsx">
            <span className="flex items-center justify-center font-heading text-base sm:hidden">
              Fix this
            </span>
            <span className="hidden items-center justify-center font-heading text-base sm:flex">
              Update payment method
            </span>
          </UpdatePaymentButton>
        </Button>
      </div>
    </Banner>;
};